import { Epic, ofType } from "redux-observable";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as actions from "./partnershipActions";
import { ServiceContainer } from "../../serviceContainer";
import { catchError, exhaustMap, map } from "rxjs/operators";
import { of } from "rxjs";

export const partnershipListEpic: Epic<
  any,
  any,
  RootState,
  ServiceContainer
> = (action$, state$, services) =>
  action$.pipe(
    ofType(actions.LIST),
    exhaustMap((action: actions.ListAction) => {
      const state = state$.value;

      return services.apiPartnership
        .listForOrganization(
          authSelectors.accessToken(state),
          action.organization
        )
        .pipe(
          map((response) =>
            actions.listSuccessAction(action.organization, response.data)
          ),
          catchError(() => {
            services.toastr.error(
              "Fail",
              "There was error while fetching partnerships list"
            );
            return of(actions.listFailAction(action.organization));
          })
        );
    })
  );
